// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZrmWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { AccountViewListingsDto, AccountViewTableCellDto, ListingAlias } from '../..';

interface InquiriesParams {
  listingAlias: ListingAlias;
}
interface LeasesParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeInactive?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface PaymentsParams {
  listingAlias: ListingAlias;
}

export const RentalManagerAccountViewZrmWebApiHandler_inquiries_Path =
  '/api/web/v1/users/accountView/zrm/properties/inquiries';

/**
 * Get zrm user account view property inquiries status
 */
export const RentalManagerAccountViewZrmWebApiHandler_inquiries = (
  getParams: InquiriesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<InquiriesParams, never, AccountViewTableCellDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmWebApiHandler_inquiries_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmWebApiHandler_leases_Path =
  '/api/web/v1/users/accountView/zrm/properties/leases';

/**
 * Get zrm user account view property leases status
 */
export const RentalManagerAccountViewZrmWebApiHandler_leases = (getParams: LeasesParams, client = getClient()) => {
  return httpFrontEndRequest<LeasesParams, never, AccountViewTableCellDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmWebApiHandler_leases_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmWebApiHandler_list_Path = '/api/web/v1/users/accountView/zrm/properties/list';

/**
 * Get zrm user account view property list
 */
export const RentalManagerAccountViewZrmWebApiHandler_list = (getParams: ListParams, client = getClient()) => {
  return httpFrontEndRequest<ListParams, never, AccountViewListingsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZrmWebApiHandler_payments_Path =
  '/api/web/v1/users/accountView/zrm/properties/payments';

/**
 * Get zrm user account view property payments status
 */
export const RentalManagerAccountViewZrmWebApiHandler_payments = (getParams: PaymentsParams, client = getClient()) => {
  return httpFrontEndRequest<PaymentsParams, never, AccountViewTableCellDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZrmWebApiHandler_payments_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
